interface IFilterFunction {
  (item: any): boolean
}

// NOTE: this used to console.debug the ENTIRE array on entry and the sum on
// exit, on every call. Its only callers are the three silo propagation
// cascades, which invoke it 7+ times per run and twice per overview display, so
// a large company serialized its whole msService list a couple of dozen times
// per page load. The callers that care already log their own result
// (e.g. CompanyMSService.ts logs company.mrcAmount), so the dumps are gone
// rather than gated — gating would make this module read Nuxt runtime config,
// which test/setup.ts deliberately does not stub.
export function sumObjectArrayProperty(
  callingFn: string,
  arr: any[],
  key: string,
  filterFunction?: IFilterFunction
) {
  if (!arr) {
    return 0
  }
  const filterFn = filterFunction || (() => true)
  return arr.filter(filterFn).reduce((a, b) => a + (parseFloat(b[key]) || 0), 0)
}
